module.exports = __webpack_public_path__ + "static/media/3.c1aea758.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/3.png
// module id = 38
// module chunks = 0